t = require('views/internal/teacup-with-helpers')('header_invite')

__avatarDomain = window.avatarDomain

getAvatarAttrs = (hash, fullName, username) ->
  text = "#{fullName} (#{username})"
  src: [__avatarDomain, hash, '30.png'].join('/')
  alt: text
  title: text

module.exports = t.renderable ({ isInviter, ghost, modelName, memberAdder, avatarHash, fullName, username, modelType, isLoggedIn, isBoard, signupUrl, isGhostEmailLoggedIn }) ->
  t.div '.invited-message', ->
    t.a '.js-ignore-invite.icon-lg.icon-close.dialog-close-button', { href: '#' }
    t.h1 ->
      if isInviter
        t.format 'you-invited-ghost-fullname-to-collaborate-on-modelname', { 'ghost.fullName': ghost.fullName, modelName }
      else
        if memberAdder
          t.format 'fullname-has-invited-you-to-collaborate-on-modelname', { fullName: memberAdder.fullName, modelName }
        else
          t.format 'youve-been-invited-to-collaborate-on-modelname', { modelName }
    if isLoggedIn
      if !isInviter
        t.p { style: 'min-height: 20px;' }, ->
          if ghost.email && !isGhostEmailLoggedIn
            t.format 'your-account'
            if avatarHash
              t.img '.inline-member-av', getAvatarAttrs(avatarHash, fullName, username)
            t.text ' '
            t.format 'fullname-username-hasnt-logged-in-with-ghost-email', { fullName, username, 'ghost.email': ghost.email }

      if isInviter
        t.a '.button.js-create-new-account.primary', { href: signupUrl }, ->
          t.format 'create-new-account-for-ghost-fullname', { 'ghost.fullName': ghost.fullName }
      else
          if isGhostEmailLoggedIn # rare case when the logged in user's email matches the ghost email
            t.a '.button.js-join-model.primary', { href: '#' }, ->
              if isBoard
                t.format 'join-board'
              else
                t.format 'join-org'
          else
            t.a '.button.js-join-model.primary', { href: '#' }, ->
              if isBoard
                t.format 'add-this-email-to-my-account-and-join-board'
              else
                t.format 'add-this-email-to-my-account-and-join-org'
            t.a '.button.js-create-new-account', { href: signupUrl }, ->
              t.format 'create-new-account'
    else
      t.a '.button.primary', { href: signupUrl }, ->
        if isBoard
          t.format 'join-board'
        else
          t.format 'join-org'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_invite.coffee